import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../../utils/metaPixel';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
  checkout?: boolean;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel,
  checkout = false
}: ButtonProps) {
  const styles = {
    primary: 'bg-amber-400 text-slate-950 shadow-sm shadow-amber-500/20 transition-[background-color,transform] hover:bg-amber-300 active:scale-[0.98]',
    secondary: 'border border-slate-700 bg-slate-900 text-white shadow-sm transition-[background-color,transform] hover:bg-slate-800 active:scale-[0.98]',
    outline: 'border border-slate-600 bg-transparent text-white transition-colors hover:bg-slate-900'
  };
  const sizes = {
    sm: 'px-5 py-2.5 text-sm',
    lg: 'px-6 py-4 text-base sm:px-10 sm:py-4 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-semibold duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 ${styles[variant]} ${sizes[size]} ${className}`;
  const handleClick = () => {
    if (checkout) trackInitiateCheckout();
    onClick?.();
  };
  if (href) {
    return <a href={href} target={target} rel={rel} onClick={handleClick} className={classes} aria-label={ariaLabel} data-id="element-193" data-mp="xmo06bmjfvtx">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-194" data-mp="17fczk84tdj8w" />}
      </a>;
  }
  return <button type="button" onClick={handleClick} className={classes} aria-label={ariaLabel} data-id="element-195" data-mp="1ldl5h5jtvuw7">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-196" data-mp="1hdj0onisqlcp" />}
    </button>;
}